/*
 * Break-even processing fee — MUST stay in sync with processingFeeCentsFor
 * in functions/index.js so the amount shown to the parent matches the charge.
 *
 * Covers Stripe's real costs, which are self-referential (the card fee applies
 * to the total charge, which includes this fee itself):
 *   card fee   = 2.9% of total charge + $0.30   (total = 1.1·S + tip + P)
 *   payout fee = 0.25% of sitter payout + $0.25 (payout = S + tip)
 * Solving P = cardFee + payoutFee for P:
 *   P = (0.0344·S + 0.0315·T + 55¢) / (1 − 0.029)
 * Rounded UP so rounding never dips a cent below cost.
 */
export function processingFeeCentsFor(serviceCents, tipCents = 0) {
  return Math.ceil((0.0344 * serviceCents + 0.0315 * tipCents + 55) / 0.971);
}

export function processingFeeDollars(serviceDollars, tipDollars = 0) {
  return processingFeeCentsFor(Math.round(serviceDollars * 100), Math.round(tipDollars * 100)) / 100;
}
